/**
 * Hook that initializes the WebSocket connection once on mount.
 */

import { useEffect, useRef } from 'react'

interface WebsocketConfig {
  initializeConnection: () => void
}

export const useWebsocketInit = (websocket: WebsocketConfig): void => {
  const hasInitializedRef = useRef(false)

  useEffect(() => {
    if (hasInitializedRef.current) return
    hasInitializedRef.current = true
    websocket.initializeConnection()
  }, [websocket])
}
